import {
  TrapezoidalRule,
  AucInterval,
  BlqRule,
} from './domain';
import type { Study, AuditEntry, MultiSubjectDataset } from './domain';

export interface AppSettings {
  theme: 'light' | 'dark' | 'system';
  defaultTrapezoidalRule: TrapezoidalRule;
  defaultAucInterval: AucInterval;
  defaultBlqRule: BlqRule;
  significantFigures: number;
  locale: string;
  autoSave: boolean;
  /**
   * Whether the "Load Demo" entry point is visible in the app header.
   * Default: true. Users can disable after onboarding to reduce clutter.
   * (Stage 10 — standard demo load/clear/toggle pattern.)
   */
  showLoadDemo: boolean;
}

export interface PersistedState {
  version: number;
  activeStudyId: string | null;
  studies: Study[];
  settings: AppSettings;
  dataset?: MultiSubjectDataset | null;
  auditTrail: AuditEntry[];
}

export const DEFAULT_SETTINGS: AppSettings = {
  theme: 'system',
  defaultTrapezoidalRule: TrapezoidalRule.LinearUpLogDown,
  defaultAucInterval: AucInterval.ZeroToInf,
  defaultBlqRule: BlqRule.M1,
  significantFigures: 4,
  locale: 'en-US',
  autoSave: true,
  showLoadDemo: true,
};

export const STORAGE_KEY = 'bioavail.state.v1';
export const STORAGE_VERSION = 1;
export const STORAGE_QUOTA_BYTES = 5 * 1024 * 1024;
